import { render } from "./videolist.vue?vue&type=template&id=63ce9fc6&scoped=true"
import script from "./videolist.vue?vue&type=script&lang=js"
export * from "./videolist.vue?vue&type=script&lang=js"

import "./videolist.vue?vue&type=style&index=0&id=63ce9fc6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63ce9fc6"],['__file',"src/js/components/videolist.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "63ce9fc6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('63ce9fc6', __exports__)) {
    api.reload('63ce9fc6', __exports__)
  }
  
  module.hot.accept("./videolist.vue?vue&type=template&id=63ce9fc6&scoped=true", () => {
    api.rerender('63ce9fc6', render)
  })

}


export default __exports__